const API_BASE = process.env.REACT_APP_API_URL || 'https://vance-production-36e9.up.railway.app';

export default API_BASE;
